export enum ClientFileKind {
  referral = 'referral',
  encounter = 'encounter',
  autoVerifyPrescriber = 'auto_verify_prescriber',
  clientPrescription = 'client_prescription'
}
